import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import './NonProfitLLCFormPage.css'; // Import the CSS file

function NonProfitLLCFormPage() {
  const location = useLocation();
  const [validationStatus, setValidationStatus] = useState('validating'); // validating, valid, invalid
  const [inviteCodeData, setInviteCodeData] = useState(null);
  const [error, setError] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false); // State for submission loading
  const [submissionStatus, setSubmissionStatus] = useState('idle'); // idle, submitting, success, error

  // State for the onboarding form (Placeholder fields for Non-Profit LLC)
  const [onboardingData, setOnboardingData] = useState({
    non_profit_name: '',
    ein_number: '',
    state_of_formation: '',
    // Add more fields relevant to Non-Profit LLC formation
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setOnboardingData({ ...onboardingData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (isSubmitting) {
      return; // Prevent multiple submissions
    }

    setIsSubmitting(true);
    setSubmissionStatus('submitting');
    setError(null); // Clear previous errors

    // Ensure inviteCodeData and inviteCode exist
    if (!inviteCodeData || !inviteCodeData.invite_code) {
      setSubmissionStatus('error');
      setError('Invite code data is missing.');
      setIsSubmitting(false);
      return;
    }

    const inviteCode = inviteCodeData.invite_code;

    try {
      // TODO: Update this endpoint for Non-Profit LLC submissions if needed
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL || 'http://localhost:8000'}/invite-codes/${inviteCode}/submit-nonprofit-onboarding`, // Tentative new endpoint
        onboardingData
      );

      console.log('Submission successful:', response.data);
      setSubmissionStatus('success');
      // Optionally clear the form or redirect the user

    } catch (err) {
      console.error('Error submitting onboarding data:', err);
      setSubmissionStatus('error');
      if (err.response && err.response.data && err.response.data.detail) {
        setError(err.response.data.detail);
      } else {
        setError('Failed to submit onboarding data.');
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const code = searchParams.get('code');

    if (!code) {
      setValidationStatus('invalid');
      setError('No invite code found in URL.');
      return;
    }

    const validateCode = async () => {
      try {
        // Adjust the URL if your backend is on a different host/port
        const response = await axios.get(`${process.env.REACT_APP_API_URL || 'http://localhost:8000'}/invite-codes/${code}`);
        setInviteCodeData(response.data);
        setValidationStatus('valid');
      } catch (err) {
        console.error('Error validating invite code:', err);
        setValidationStatus('invalid');
        if (err.response && err.response.data && err.response.data.detail) {
          setError(err.response.data.detail);
        } else {
          setError('Failed to validate invite code.');
        }
      }
    };

    validateCode();
  }, [location.search]);

  return (
    <div className="non-profit-llc-form-page">
      <h1>Non-Profit LLC On-boarding</h1>
      {
        validationStatus === 'validating' && (
          <p className="validation-loading">Validating invite code</p>
        )
      }
      {
        validationStatus === 'valid' && inviteCodeData && (
          <>
            <h2>Non-Profit LLC Formation Questionnaire</h2>
            <form onSubmit={handleSubmit} className="non-profit-llc-form">
              {/* Placeholder Form Fields */}
              <div className="form-group">
                <label htmlFor="non_profit_name">Non-Profit Organization Name:</label>
                <input
                  type="text"
                  id="non_profit_name"
                  name="non_profit_name"
                  value={onboardingData.non_profit_name}
                  onChange={handleInputChange}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="ein_number">EIN Number (if applicable):</label>
                <input
                  type="text"
                  id="ein_number"
                  name="ein_number"
                  value={onboardingData.ein_number}
                  onChange={handleInputChange}
                />
              </div>

               <div className="form-group">
                <label htmlFor="state_of_formation">State of Formation:</label>
                <input
                  type="text"
                  id="state_of_formation"
                  name="state_of_formation"
                  value={onboardingData.state_of_formation}
                  onChange={handleInputChange}
                  required
                />
              </div>

              {/* Add more form fields here */}

              <button
                type="submit"
                disabled={isSubmitting}
              >
                {isSubmitting ? 'Submitting...' : 'Submit Onboarding Info'}
              </button>
            </form>
          </>
        )
      }
      {
        validationStatus === 'invalid' && error && (
          <p className="validation-error">Error: {error}</p>
        )
      }
       {
        submissionStatus === 'success' && (
          <p className="submission-success">Onboarding information submitted successfully!</p>
        )
      }
      {
        submissionStatus === 'error' && error && (
          <p className="submission-error">Submission Error: {error}</p>
        )
      }
    </div>
  );
}

export default NonProfitLLCFormPage; 